import { useEffect, useState } from "react";
import Footer from "../../comps/Footer";
import Header from "../../comps/Header";
import { get_terms_conditions_data } from "../../api/Global";

const TermsOfService = () => {
      const [get_terms_conditions, set_terms_conditions] = useState({});

      useEffect(() => {
            const handle_get_terms_conditions = async () => {
                  try {
                        const response = await get_terms_conditions_data();
                        set_terms_conditions(response?.data?.data?.terms_conditions);
                  }
                  catch (error) {
                        console.log("error", error)
                  }
            }
            handle_get_terms_conditions()
      }, [])
     
      // <-------- fetch the top on the page -------------->
      useEffect(() => {
            window.scrollTo(0, 0)
      }, [])
      return (
            <>
                  <Header />
                  <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
                        <div className="relative">
                              <h1 className="text-5xl font-bold text-black mb-12 text-center">Terms of Service</h1>
                              <div className="space-y-12 text-white">
                                    <section className=" bg-[white]/95 text-black p-8 rounded-2xl border border-[#333438] hover:border-light-500 transition-all duration-300 backdrop-blur-sm">
                                          <h2 className="text-2xl font-bold theme_color mb-4 text-black">{get_terms_conditions?.title}</h2>
                                          <div className=" mb-4 privacy_terms text-gray-900" dangerouslySetInnerHTML={{ __html: get_terms_conditions?.content }}></div>
                                    </section>
                              </div>
                        </div>
                  </div>
                  <Footer />
            </>
      );
};

export default TermsOfService;
